import { render, staticRenderFns } from "./detectionIndex.vue?vue&type=template&id=6e388548&scoped=true&"
import script from "./detectionIndex.vue?vue&type=script&lang=js&"
export * from "./detectionIndex.vue?vue&type=script&lang=js&"
import style0 from "./detectionIndex.vue?vue&type=style&index=0&id=6e388548&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e388548",
  null
  
)

export default component.exports